import * as React from "react";

import { Body1, Field, Spinner, Title1 } from "@fluentui/react-components";
import { useLocation, useNavigate } from "react-router-dom";

import { useStyles } from "./styles";
import Button from "../../../../components/Button/Button";
import { CitationStorageService } from "../../../../service/citationStorage.service";
import { useCitationStore } from "../../../../store/CitationStore";

export interface HomeComponentProps {
  refreshTrigger: number;
  onRefreshMatches: () => void;
}

const HomeComponent: React.FC<HomeComponentProps> = ({ refreshTrigger }) => {
  console.log("refreshTrigger", refreshTrigger);
  const styles = useStyles();
  const [isCheckingResults, setIsCheckingResults] = React.useState(true);
  const [skipChecks, setSkipChecks] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { citations, isLoaded, loadCitationsFromStorage } = useCitationStore();

  // Check if we came from the Cleaning page
  const fromCleaning = (location.state as { fromCleaning?: boolean })?.fromCleaning;

  // If we came from cleaning, mark to skip checks and clear the state
  React.useEffect(() => {
    if (fromCleaning) {
      console.log("Just cleaned citations - will skip storage checks");
      setSkipChecks(true);
      setIsCheckingResults(false);
      // Clear the navigation state so browser refresh works normally
      window.history.replaceState({}, document.title);
    }
  }, [fromCleaning]);

  React.useEffect(() => {
    // Skip if we just came from cleaning
    if (fromCleaning || skipChecks) {
      return;
    }

    const checkExistingResults = async () => {
      try {
        setIsCheckingResults(true);

        // Step 1: Check if context already has citations
        if (isLoaded && citations.length > 0) {
          console.log("Citations already in context, navigating to executive summary");
          navigate("/executive-summary");
          return;
        }

        // Step 2: Check if citations exist in storage
        const resultsExist = await CitationStorageService.citationResultsExist();
        console.log("Citation results exist in storage:", resultsExist);

        if (resultsExist) {
          // Step 3: Load citations into context and navigate
          console.log("Loading citations from storage into context...");
          const loaded = await loadCitationsFromStorage();
          if (loaded) {
            console.log("Citations loaded, navigating to executive summary");
            navigate("/executive-summary");
          }
        }
        // Step 4: If no citations, stay on home (do nothing)
      } catch (error) {
        console.error("Failed to check citation results existence:", error);
        // Continue with normal home page flow if check fails
      } finally {
        setIsCheckingResults(false);
      }
    };

    checkExistingResults();
  }, [skipChecks]);

  const handleSearch = async () => {
    // navigates to the scanning page
    navigate("/scanning");
  };

  if (isCheckingResults) {
    return (
      <div className={styles.container}>
        <Title1>Home</Title1>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            paddingTop: "40px",
          }}
        >
          <Spinner size="large" />
          <Body1 style={{ textAlign: "center" }}>Checking for existing scan results...</Body1>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Title1>Home</Title1>
      {/* <DocumentScanner refreshTrigger={refreshTrigger} /> */}
      <Field className={styles.instructions}>
        Scan the document for potential legal citations and references.
      </Field>

      <div className={styles.buttonGroup}>
        <Button variant="primary" size="large" onClick={handleSearch}>
          Scan
        </Button>
      </div>
    </div>
  );
};

export default HomeComponent;
